import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import classes from './InfoPage.module.scss';
import sitemapClasses from './Sitemap.module.scss';
import { INFO_PAGES } from './infoPagesContent';

export const Sitemap = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={classes.Page}>
            <h1 className={classes.PageTitle}>Sitemap</h1>

            <div className={classes.Section}>
                <p className={classes.Paragraph}>Every page currently live on this site.</p>

                <ul className={sitemapClasses.LinkList}>
                    <li>
                        <Link className={sitemapClasses.Link} to="/">
                            Home
                        </Link>
                    </li>
                    {Object.entries(INFO_PAGES).map(([slug, page]) => (
                        <li key={slug}>
                            <Link className={sitemapClasses.Link} to={`/${slug}`}>
                                {page.title}
                            </Link>
                        </li>
                    ))}
                    <li>
                        <Link className={sitemapClasses.Link} to="/sitemap">
                            Sitemap
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default Sitemap;
